"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 404,
    "errors": {
        "key": [
            "PortfolioKey not found."
        ]
    }
};
